import React from 'react'

import Navbar from '../../components/main/layouts/Navbar';
import MainSection from './sections/AboutUs/MainSection';
import FooterSection from '../../components/main/layouts/FooterSection'

function AboutusPapakilo() {
  return (
    <div className='h-screen select-none overflow-y-scroll' id='no-scrollbar'>
     <Navbar />
     <MainSection />
     <FooterSection />
   </div>
  )
}

export default AboutusPapakilo